export const THEMES = {
  gold:       { bg:"#080e1a", bg2:"#0d1625", bg3:"rgba(17,31,53,0.8)",  bg4:"rgba(22,37,64,0.65)",  grad1:"#C8A84B", grad2:"#E4C97A", accent:"#C8A84B", cardBorderTop:"rgba(200,168,75,0.6)",  cardBorderBot:"rgba(200,168,75,0.2)"  },
  teal:       { bg:"#060f12", bg2:"#0a1820", bg3:"rgba(10,28,36,0.8)",  bg4:"rgba(14,36,46,0.65)",  grad1:"#1a8fa0", grad2:"#2ABFCF", accent:"#2ABFCF", cardBorderTop:"rgba(42,191,207,0.6)",  cardBorderBot:"rgba(42,191,207,0.2)"  },
  purple:     { bg:"#08060f", bg2:"#100d1e", bg3:"rgba(20,15,40,0.8)",  bg4:"rgba(28,20,55,0.65)",  grad1:"#7B6FD0", grad2:"#A99EE8", accent:"#A99EE8", cardBorderTop:"rgba(169,158,232,0.6)", cardBorderBot:"rgba(169,158,232,0.2)" },
  green:      { bg:"#060f09", bg2:"#0a1a0e", bg3:"rgba(10,28,16,0.8)",  bg4:"rgba(14,38,20,0.65)",  grad1:"#2A9E60", grad2:"#4AC87A", accent:"#4AC87A", cardBorderTop:"rgba(74,200,122,0.6)",  cardBorderBot:"rgba(74,200,122,0.2)"  },
  sun:        { bg:"#1a0f04", bg2:"#241608", bg3:"rgba(40,24,8,0.8)",   bg4:"rgba(52,32,12,0.65)",  grad1:"#E8922A", grad2:"#F5C842", accent:"#F5C842", cardBorderTop:"rgba(245,200,66,0.6)",  cardBorderBot:"rgba(245,200,66,0.2)"  },
  psychic:    { bg:"#0a0416", bg2:"#120820", bg3:"rgba(22,10,40,0.8)",  bg4:"rgba(32,14,56,0.65)",  grad1:"#9B30FF", grad2:"#D580FF", accent:"#D580FF", cardBorderTop:"rgba(213,128,255,0.6)", cardBorderBot:"rgba(213,128,255,0.2)" },
  paranormal: { bg:"#040a0a", bg2:"#081414", bg3:"rgba(8,22,22,0.8)",   bg4:"rgba(12,32,30,0.65)", grad1:"#00C9A7", grad2:"#80FFE8", accent:"#80FFE8", cardBorderTop:"rgba(128,255,232,0.6)", cardBorderBot:"rgba(128,255,232,0.2)" },
  // Game-level unlocked themes
  neon:       { bg:"#05020f", bg2:"#0a0520", bg3:"rgba(14,6,36,0.85)",  bg4:"rgba(20,8,52,0.65)",   grad1:"#FF2D87", grad2:"#FF9F00", accent:"#FF2D87", cardBorderTop:"rgba(255,45,135,0.6)",  cardBorderBot:"rgba(255,45,135,0.2)"  },
  midnight:   { bg:"#000308", bg2:"#000814", bg3:"rgba(0,10,24,0.9)",   bg4:"rgba(0,15,36,0.7)",    grad1:"#0066FF", grad2:"#00CFFF", accent:"#00CFFF", cardBorderTop:"rgba(0,207,255,0.6)",   cardBorderBot:"rgba(0,207,255,0.2)"   },
  crimson:    { bg:"#0f0204", bg2:"#1a0408", bg3:"rgba(28,6,10,0.85)",  bg4:"rgba(40,8,14,0.65)",   grad1:"#C0392B", grad2:"#FF6B6B", accent:"#FF6B6B", cardBorderTop:"rgba(255,107,107,0.6)", cardBorderBot:"rgba(255,107,107,0.2)" },
  nebula:     { bg:"#040816", bg2:"#071020", bg3:"rgba(10,18,40,0.85)", bg4:"rgba(14,24,52,0.65)",  grad1:"#7B2FBE", grad2:"#FF8C42", accent:"#FF8C42", cardBorderTop:"rgba(255,140,66,0.6)",  cardBorderBot:"rgba(255,140,66,0.2)"  },
};

/** Per-theme game level requirement for unlocking (null = always available) */
export const THEME_UNLOCK_LEVEL = {
  gold:       null,
  teal:       null,
  purple:     null,
  green:      null,
  sun:        null,  // premium license required (existing)
  psychic:    null,  // premium license required (existing)
  paranormal: null,  // premium license required (existing)
  neon:       5,
  midnight:   10,
  crimson:    20,
  nebula:     30,
};

export let _T = THEMES.gold;
export function getTheme(id) { return THEMES[id] || THEMES.gold; }
export function setThemeGlobal(id) { _T = getTheme(id); }

export const C = {
  silver:"#8899BB",
  silver2:"#b0c0d8",
  white:"#EEF3FF",
  purple:"#7B6FD0",
  teal:"#2A9E82",
  red:"#C05050",
  orange:"#D4873A",
};

/** Tab animation class per theme — apply to tab content wrapper */
export const THEME_TAB_CLASS = {
  gold:       'tab-anim-gold',
  teal:       'tab-anim-teal',
  purple:     'tab-anim-purple',
  green:      'tab-anim-green',
  sun:        'tab-anim-sun',
  psychic:    'tab-anim-psychic',
  paranormal: 'tab-anim-paranormal',
  neon:       'tab-anim-neon',
  midnight:   'tab-anim-midnight',
  crimson:    'tab-anim-crimson',
  nebula:     'tab-anim-nebula',
};

export const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
*{box-sizing:border-box;-webkit-font-smoothing:antialiased;}
body,html{font-size:16px;line-height:1.55;}
::-webkit-scrollbar{width:3px;}

/* ── Base keyframes ─────────────────────────────────────── */
@keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
@keyframes fadeDown{from{opacity:0;transform:translateY(-20px)}to{opacity:1;transform:translateY(0)}}
@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}
@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
@keyframes popIn{from{opacity:0;transform:scale(0.6)}to{opacity:1;transform:scale(1)}}
@keyframes slideIn{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:translateX(0)}}
@keyframes notifSlide{from{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:translateY(0)}}
@keyframes techScan{0%{left:-55%;width:50%}70%{left:90%;width:60%}100%{left:110%;width:50%}}
@keyframes techGlow{0%,100%{opacity:1}50%{opacity:0.25}}
@keyframes techBlink{0%,49%{opacity:1}50%,100%{opacity:0}}
@keyframes techDot{0%,100%{transform:scaleY(0.4);opacity:0.3}50%{transform:scaleY(1);opacity:1}}
.fadeUp{animation:fadeUp 0.4s ease both;}
.fadeDown{animation:fadeDown 0.35s ease both;}
.pulse{animation:pulse 4s ease-in-out infinite;}
.spin{animation:spin 1s linear infinite;}
.popIn{animation:popIn 0.2s ease both;}
.slideIn{animation:slideIn 0.3s ease both;}
.notifSlide{animation:notifSlide 0.35s cubic-bezier(0.34,1.2,0.64,1) both;}

/* ── Per-theme tab transition keyframes ─────────────────── */
@keyframes tabGold      {from{opacity:0;transform:translateY(10px) scale(0.98)}to{opacity:1;transform:translateY(0) scale(1)}}
@keyframes tabTeal      {from{opacity:0;transform:translateX(18px)}to{opacity:1;transform:translateX(0)}}
@keyframes tabPurple    {from{opacity:0;transform:scale(0.93) translateY(6px)}to{opacity:1;transform:scale(1) translateY(0)}}
@keyframes tabGreen     {from{opacity:0;transform:translateY(20px) scaleY(0.94)}to{opacity:1;transform:translateY(0) scaleY(1)}}
@keyframes tabSun       {from{opacity:0;transform:translateX(-18px)}to{opacity:1;transform:translateX(0)}}
@keyframes tabPsychic   {0%{opacity:0;transform:translateX(-5px) skewX(-4deg)}30%{opacity:1;transform:translateX(3px) skewX(2deg)}60%{transform:translateX(-2px) skewX(-1deg)}100%{transform:translateX(0) skewX(0)}}
@keyframes tabParanormal{from{opacity:0;filter:blur(10px);transform:scale(1.04)}to{opacity:1;filter:blur(0);transform:scale(1)}}
@keyframes tabNeon      {0%{opacity:0;transform:translateY(8px)}40%{opacity:1}60%{transform:translateY(-3px)}100%{transform:translateY(0)}}
@keyframes tabMidnight  {from{opacity:0;transform:translateX(-20px) scale(0.97)}to{opacity:1;transform:translateX(0) scale(1)}}
@keyframes tabCrimson   {from{opacity:0;transform:scale(1.06) translateY(-8px)}to{opacity:1;transform:scale(1) translateY(0)}}
@keyframes tabNebula    {0%{opacity:0;filter:blur(8px);transform:rotate(-1deg) scale(0.95)}100%{opacity:1;filter:blur(0);transform:rotate(0) scale(1)}}
@keyframes purpleZoom   {from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}
@keyframes ghostFade    {from{opacity:0;filter:blur(6px)}to{opacity:1;filter:blur(0)}}

.tab-anim-gold      {animation:tabGold       0.35s cubic-bezier(0.34,1.15,0.64,1) both;}
.tab-anim-teal      {animation:tabTeal       0.38s cubic-bezier(0.22,1,0.36,1)    both;}
.tab-anim-purple    {animation:tabPurple     0.36s cubic-bezier(0.34,1.3,0.64,1)  both;}
.tab-anim-green     {animation:tabGreen      0.38s cubic-bezier(0.34,1.2,0.64,1)  both;}
.tab-anim-sun       {animation:tabSun        0.38s cubic-bezier(0.22,1.2,0.36,1)  both;}
.tab-anim-psychic   {animation:tabPsychic    0.42s steps(5,end)                   both;}
.tab-anim-paranormal{animation:tabParanormal 0.45s ease                           both;}
.tab-anim-neon      {animation:tabNeon       0.35s cubic-bezier(0.34,1.2,0.64,1)  both;}
.tab-anim-midnight  {animation:tabMidnight   0.38s cubic-bezier(0.22,1,0.36,1)    both;}
.tab-anim-crimson   {animation:tabCrimson    0.36s cubic-bezier(0.34,1.3,0.64,1)  both;}
.tab-anim-nebula    {animation:tabNebula     0.45s ease                           both;}

/* ── Per-theme button active effects ────────────────────── */
[data-theme] button{transition:transform 0.1s ease,box-shadow 0.2s ease,opacity 0.1s ease;}
[data-theme] button:active{transform:scale(0.95);}

[data-theme="gold"]       button:active{box-shadow:0 0 0 5px #C8A84B30,0 0 18px #C8A84B40;transform:scale(0.95);}
[data-theme="teal"]       button:active{box-shadow:0 0 0 5px #2ABFCF30,0 0 18px #2ABFCF40;transform:scale(0.95);}
[data-theme="purple"]     button:active{box-shadow:0 0 0 5px #A99EE830,0 0 18px #A99EE840;transform:scale(0.95);}
[data-theme="green"]      button:active{box-shadow:0 0 0 5px #4AC87A30,0 0 18px #4AC87A40;transform:scale(0.95);}
[data-theme="sun"]        button:active{box-shadow:0 0 0 5px #F5C84230,0 0 18px #F5C84240;transform:scale(0.95);}
[data-theme="psychic"]    button:active{box-shadow:0 0 0 5px #D580FF30,0 0 18px #D580FF40;transform:scale(0.95) skewX(-1deg);}
[data-theme="paranormal"] button:active{box-shadow:0 0 0 5px #80FFE830,0 0 22px #80FFE850;transform:scale(0.95);}
[data-theme="neon"]       button:active{box-shadow:0 0 0 5px #FF2D8730,0 0 22px #FF2D8750;transform:scale(0.95);}
[data-theme="midnight"]   button:active{box-shadow:0 0 0 5px #00CFFF30,0 0 22px #00CFFF50;transform:scale(0.95);}
[data-theme="crimson"]    button:active{box-shadow:0 0 0 5px #FF6B6B30,0 0 22px #FF6B6B50;transform:scale(0.95);}
[data-theme="nebula"]     button:active{box-shadow:0 0 0 5px #FF8C4230,0 0 22px #FF8C4250;transform:scale(0.95);}

/* Glowing border sweep on focused/selected buttons per theme */
[data-theme="gold"]       .btn-active{box-shadow:0 0 0 2px #C8A84B,0 0 12px #C8A84B66;}
[data-theme="teal"]       .btn-active{box-shadow:0 0 0 2px #2ABFCF,0 0 12px #2ABFCF66;}
[data-theme="purple"]     .btn-active{box-shadow:0 0 0 2px #A99EE8,0 0 12px #A99EE866;}
[data-theme="green"]      .btn-active{box-shadow:0 0 0 2px #4AC87A,0 0 12px #4AC87A66;}
[data-theme="sun"]        .btn-active{box-shadow:0 0 0 2px #F5C842,0 0 12px #F5C84266;}
[data-theme="psychic"]    .btn-active{box-shadow:0 0 0 2px #D580FF,0 0 12px #D580FF66;}
[data-theme="paranormal"] .btn-active{box-shadow:0 0 0 2px #80FFE8,0 0 14px #80FFE877;}
[data-theme="neon"]       .btn-active{box-shadow:0 0 0 2px #FF2D87,0 0 14px #FF2D8777;}
[data-theme="midnight"]   .btn-active{box-shadow:0 0 0 2px #00CFFF,0 0 14px #00CFFF77;}
[data-theme="crimson"]    .btn-active{box-shadow:0 0 0 2px #FF6B6B,0 0 14px #FF6B6B77;}
[data-theme="nebula"]     .btn-active{box-shadow:0 0 0 2px #FF8C42,0 0 14px #FF8C4277;}
`;
